<template>
  <div id="MyModal" v-if="showModal">
    <div
      class="contentModal"
      :class="{ open: showModal, 'biometric-modal': biometricModal }"
    >
      <span class="material-icons closeOrder" @click="emitClose">close</span>
      <h3>{{ title }}</h3>
      <p class="sub">{{ subtitle }}</p>
      <p v-if="text" class="text">{{ text }}</p>
      <div
        class="contentButton"
        :class="{ 'biometric-layout': biometricModal }"
      >
        <button
          class="cdlButton"
          @click="emitDelete"
          :style="
            biometricModal
              ? 'width: 48% !important; border: 2px solid #007bff !important; background-color: white !important; background-image: none !important; color: #007bff !important; opacity: 1 !important; border-radius: 41px !important; padding: 20px !important; text-align: center !important; font-family: OpenSansRegular !important; font-size: 1.2rem !important;'
              : 'width: 100%;'
          "
        >
          {{ deleteButtonText }}
        </button>
        <br v-if="!biometricModal" /><br v-if="!biometricModal" />
        <button
          class="deleteOrder"
          @click="emitClose"
          :style="
            biometricModal
              ? 'width: 48% !important; border: 2px solid #007bff !important; background-color: white !important; background-image: none !important; color: #007bff !important; opacity: 1 !important; border-radius: 41px !important; padding: 20px !important; text-align: center !important; text-decoration: none !important; font-family: OpenSansRegular !important; font-size: 1.2rem !important;'
              : ''
          "
        >
          {{ revertDeleteText }}
        </button>
      </div>
    </div>
  </div>
</template>
<!--<div id="MyModal" v-if="viewModal">-->
<!--<div class="contentModal" :class="{ open: viewModal }">-->
<!--        <span class="material-icons closeOrder" @click="closeModal()"-->
<!--        >close</span-->
<!--        >-->
<!--  <h3>{{ $t("companies.titleDelete") }}</h3>-->
<!--  <p class="sub">-->
<!--    {{-->
<!--      $t("users.subTitleDelete", {-->
<!--        name: selectedCompany.company_name,-->
<!--      })-->
<!--    }}-->
<!--  </p>-->
<!--  <p class="text">{{ $t("users.textDelete") }}</p>-->
<!--  <div class="contentButton">-->
<!--    <button-->
<!--        id="closeModal"-->
<!--        class="cdlButton"-->
<!--        @click="deleteCompany(selectedCompany.id)"-->
<!--    >-->
<!--      {{ $t("users.btnDelete") }}-->
<!--    </button>-->
<!--    <br/><br/>-->
<!--    <p class="deleteOrder" @click="closeModal()">-->
<!--      {{ $t("users.revertDelete") }}-->
<!--    </p>-->
<!--  </div>-->
<!--</div>-->
<!--</div>-->

<script setup>
import { defineEmits, defineProps } from "vue";

defineProps({
  showModal: Boolean,
  title: String,
  subtitle: String,
  text: String,
  deleteButtonText: String,
  revertDeleteText: String,
  biometricModal: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["delete", "close"]);

const emitDelete = () => {
  emit("delete");
};

const emitClose = () => {
  emit("close");
};
</script>

<style lang="scss">
#MyModal .contentModal.biometric-modal {
  width: min(520px, 90vw);
  max-height: 80vh;
  overflow-y: auto;

  .sub,
  .text {
    font-size: 0.95rem;
    line-height: 1.4;
    margin: 12px 0;
  }
}

.contentButton {
  &.biometric-layout {
    display: flex;
    justify-content: space-between;
    gap: 4%;
    margin-top: 20px;
  }
}

.deleteOrder {
  display: block;
  text-align: center;
  text-decoration: underline;
  margin: 20px auto 0 auto;
  cursor: pointer;
  background: none;
  border: none;
  color: inherit;
  font: inherit;
  padding: 0;
  outline: none;

  &:hover {
    font-weight: bold;
  }

  // Enhanced styles for better button appearance
  &:focus {
    outline: 2px solid #007bff;
    outline-offset: 2px;
  }

  &:active {
    transform: translateY(1px);
  }
}
</style>
